import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-view-booking',
  templateUrl: './view-booking.component.html',
  styleUrls: ['./view-booking.component.css']
})
export class ViewBookingComponent implements OnInit, OnDestroy {
  selectedBooking$: Observable<any>;
  tourPriceMap = {
    soweto: 50,
    'sun city': 75,
    'union building': 40,
    'gold reef city': 65
  };
  mealsMap;
  hotelsMap;
  mealsSubscription: Subscription;
  hotelsSubscription: Subscription;
  constructor(private store: Store<State>) {}

  ngOnInit() {
    this.selectedBooking$ = this.store.select(
      state => state.booking.selectedBookingToView
    );
    this.mealsSubscription = this.store
      .select(state => state.booking.meals)
      .subscribe(meals => (this.mealsMap = meals));
    this.hotelsSubscription = this.store
      .select(state => state.booking.availableRooms)
      .pipe(
        map(pac => {
          const hotelsMap = pac.reduce(
            (entities: { [id: string]: number }, hotel: any) => {
              return {
                ...entities,
                [hotel.name]: hotel.price
              };
            },
            {}
          );
          return hotelsMap;
        })
      )
      .subscribe(p => (this.hotelsMap = p));
  }

  ngOnDestroy() {
    if (this.mealsSubscription) {
      this.mealsSubscription.unsubscribe();
    }
    if (this.hotelsSubscription) {
      this.hotelsSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/view-booking/view-booking.component.ts